import rightBorder from "../../assets/images/topborder.svg";
import leftBorder from "../../assets/images/topborder.svg";
import React, {useEffect, useState} from "react";
import "./PrettyBox.scss"
import axiosServise from "../ApiService";



export default function PrettyBox(props) {
    const [IsHide, setIsHide] = useState(true);
    let root = document.documentElement;
    root.style.setProperty('--imgHeight',!IsHide?props.Height:'0');
    root.style.setProperty('--imgOpacity',!IsHide?'100%':'0');
    useEffect(() => {
        setIsHide(false)


    }, []);
    function imageClick() {
        setIsHide(!IsHide)

        console.log(IsHide);
        // root.style.setProperty('--imgHeight',!IsHide?props.Height:'0');
        // root.style.setProperty('--imgOpacity',!IsHide?'100%':'0');
        root.style.setProperty('--imgHeightDuration','400ms');

        return undefined;
    }
    return <div className='hadis-section2' style={{width: props.Width}}>
        {/*<img src={rightBorder} className="hadis-border2"  alt=""/>*/}
        <div className={'hadis-box2 w-100 heightImg'}>
            <div className={'opacityImg'}>
                {!IsHide && props.children}
            </div>
        </div>
            <img src={leftBorder} className="left-border hadis-border2" alt=""  onClick={imageClick}/>
    </div>
}